module.exports = __webpack_public_path__ + "img/szw2.92ea7f9a.jpg";